import { PermissionKey } from "./permissionsCatalog";

export default {
  "https://www.googleapis.com/auth/drive": [
    PermissionKey.READ_FILES,
    PermissionKey.UPLOAD_FILES,
    PermissionKey.EDIT_FILES,
    PermissionKey.DELETE_FILES,
  ],

  "https://www.googleapis.com/auth/drive.appdata": [PermissionKey.MANAGE_APP_DATA],

  "https://www.googleapis.com/auth/drive.file": [
    PermissionKey.READ_FILES,
    PermissionKey.UPLOAD_FILES,
    PermissionKey.EDIT_FILES,
    PermissionKey.DELETE_FILES,
  ],

  "https://www.googleapis.com/auth/drive.meet.readonly": [PermissionKey.READ_FILES, PermissionKey.DOWNLOAD_FILES],

  "https://www.googleapis.com/auth/drive.metadata": [PermissionKey.VIEW_METADATA, PermissionKey.MANAGE_METADATA],

  "https://www.googleapis.com/auth/drive.metadata.readonly": [PermissionKey.VIEW_METADATA],

  "https://www.googleapis.com/auth/drive.photos.readonly": [
    PermissionKey.VIEW_PHOTOS,
    PermissionKey.VIEW_VIDEOS,
    PermissionKey.VIEW_ALBUMS,
  ],

  "https://www.googleapis.com/auth/drive.readonly": [PermissionKey.READ_FILES, PermissionKey.DOWNLOAD_FILES],
};
